import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';
import { QueryType } from 'store/slices/query';

export type TableCompanyHook = string[];

export default function useTableCompany(
  queryType: QueryType,
): TableCompanyHook {
  const [query] = useQuery(queryType);
  const searchWords = useSearchWords(query);
  return searchWords;
}
